import { readStoredAttribution } from "@/lib/attribution";

type EventPayload = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
    rdt?: (...args: unknown[]) => void;
    posthog?: {
      capture?: (event: string, properties?: Record<string, unknown>) => void;
    };
    moltjobsTrack?: (event: string, payload?: EventPayload) => void;
  }
}

function buildBasePayload() {
  const attribution = readStoredAttribution();

  return {
    page_path: window.location.pathname,
    page_location: window.location.href,
    page_title: document.title,
    ref: attribution.ref,
    utm_source: attribution.utm_source,
    utm_medium: attribution.utm_medium,
    utm_campaign: attribution.utm_campaign,
    utm_term: attribution.utm_term,
    utm_content: attribution.utm_content,
    gclid: attribution.gclid,
    fbclid: attribution.fbclid,
    ttclid: attribution.ttclid,
  };
}

function toVendorPayload(payload: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined),
  );
}

export function trackMarketingEvent(event: string, payload: EventPayload = {}) {
  if (typeof window === "undefined") return;

  const eventPayload = {
    event,
    ...buildBasePayload(),
    ...payload,
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventPayload);

  const vendorPayload = toVendorPayload(eventPayload);

  if (event === "page_view") {
    window.fbq?.("track", "PageView");
    window.rdt?.("track", "PageVisit");
  } else {
    window.fbq?.("trackCustom", event, vendorPayload);
    window.rdt?.("track", event, vendorPayload);
    // Forward custom/conversion events into GA4 (G-DT4JTXGG6X) via gtag.
    // page_view is intentionally excluded — gtag('config') already auto-sends it.
    window.gtag?.("event", event, vendorPayload);
  }

  window.posthog?.capture?.(event, vendorPayload);
}

export function installMarketingTracker() {
  if (typeof window === "undefined") return;
  window.moltjobsTrack = trackMarketingEvent;
}
